var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8344 9.99287C11.9199 10.1408 12.0257 10.2728 12.1472 10.386C12.1823 10.4517 12.2365 10.5092 12.3096 10.5498L19.9539 14.7934C19.9966 14.8171 20.0408 14.8323 20.085 14.8398C20.1924 14.882 20.3182 14.8799 20.4328 14.8163L28.0771 10.5726C28.1457 10.5345 28.1976 10.4816 28.2328 10.421C28.3588 10.3056 28.4683 10.1702 28.5562 10.0179L30.4808 6.68444C30.7831 6.16094 30.7842 5.51623 30.4837 4.99171L28.5932 1.6913C28.2897 1.16138 27.7249 0.83532 27.1143 0.837407L23.3108 0.850401C22.7063 0.852466 22.1485 1.17578 21.8463 1.69927L20.2026 4.54624L18.5444 1.67419C18.2422 1.15069 17.6844 0.827385 17.0799 0.82532L13.2764 0.812327C12.6657 0.810241 12.101 1.1363 11.7974 1.66622L9.90694 4.96663C9.60649 5.49115 9.60759 6.13586 9.90983 6.65936L11.8344 9.99287Z",
    fill: "url(#paint0_linear_202_1574)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_202_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5893 29.6745C30.2517 30.103 29.728 30.3781 29.1402 30.3781H15.6901L7.7244 38.3438C6.59927 39.4689 4.77508 39.4689 3.64996 38.3438C3.34436 38.0382 3.12177 37.681 2.98218 37.3003C2.71981 36.5847 2.09554 35.8779 1.5566 35.339C0.814468 34.5968 0.814468 33.3936 1.5566 32.6515L11.6357 22.5724C11.6494 22.5586 11.6634 22.5451 11.6775 22.5319C11.8822 22.306 12.1546 22.1372 12.4734 22.0605L24.1641 19.2485C25.0078 19.0455 25.8564 19.565 26.0593 20.4088C26.2623 21.2526 25.7428 22.1011 24.8991 22.3041L19.4289 23.6198C18.5034 23.8424 18.397 25.1165 19.2728 25.4895C19.8066 25.7169 20.3724 25.8602 20.9501 25.9144L27.0842 26.4896L33.6184 19.9554C34.0006 19.5732 34.6202 19.5732 35.0024 19.9554C35.1959 20.1488 35.2914 20.4031 35.289 20.6567L36.6702 19.2755C37.2664 18.6793 38.2331 18.6793 38.8293 19.2755C39.4255 19.8717 39.4255 20.8383 38.8293 21.4345L30.5893 29.6745Z",
    fill: "url(#paint1_linear_202_1574)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_202_1574",
    x: 0.0232286,
    y: 17.8515,
    width: 42.1835,
    height: 24.2664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.976771,
    dy: 0.976771
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976771
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_1574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_1574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_1574",
    x1: 30.7081,
    y1: 0.812317,
    x2: 9.68237,
    y2: 0.812317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_1574",
    x1: 39.2766,
    y1: 18.8283,
    x2: 1,
    y2: 18.8283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/care.182b235cb8b57439de0b0722db30e100.svg";
export { ForwardRef as ReactComponent };